import React from 'react';

const Card = ({
    image,
    title,
    desc,
    imageHeight,
    imageWidth,
    onClick
}) => {

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-around',
            width: '24%',
            minWidth: '200px',
            height: '300px',
            alignItems: 'center',
            borderRadius: '12px',
            margin: 'auto'
        }}
        >
            <div style={{
                height: `${imageHeight}`,
                width: `${imageWidth}`,
                margin: 'auto 0',
                cursor: 'pointer',
                backgroundImage: `url('${image}')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                cursor: 'pointer'
            }}
                onClick={onClick}
            />
            <div style={{
                height: '100px',
                marginTop: '20px'
            }}>
                <p style={{ margin: 0, fontSize: 'small', fontWeight: 500, cursor: 'default' }}>{title}</p>
                <p style={{ margin: '8px auto 0 auto', fontWeight: 200, width: '95%', cursor: 'default' }}>{desc}</p>
            </div>
        </div>
    )
}

export default Card;